import { createBrowserRouter } from 'react-router';
import { Landing } from './pages/Landing';
import { Portal } from './pages/Portal';
import { PreviewPortal } from './pages/PreviewPortal';
import { PreviewPhotos } from './pages/PreviewPhotos';
import { NotFound } from './pages/NotFound';

export const router = createBrowserRouter([
  { path: '/', element: <Landing /> },
  // Preview routes MUST come before the wildcard /:slug so they're not swallowed.
  { path: '/preview/:slug/photos', element: <PreviewPhotos /> },
  { path: '/preview/:slug', element: <PreviewPortal /> },
  { path: '/:slug', element: <Portal /> },
  { path: '*', element: <NotFound /> },
]);
